export default "__VITE_ASSET__f7HIoFz2__"